import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Buttons from "../components/elements/Button";
import LoginBtn from "../components/LoginBtn";
import { TitleHeader } from "../components/elements/Header";
import errorimg from "../assets/svg/errordata.svg";
import { navigate } from "@reach/router";
import { useShop } from "../context/ShopContext";
import generateOmbreHMAC from "../context/generateOmbreHMAC";
import axios from "axios";

const Container = styled.div`
  padding: 0px;
  padding-left: 16px;
  padding-right: 16px;
  margin-top: 25px;
`;

const Error = styled.h1`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #fffcf2;
  margin-top: 5px;
  opacity: 0.5;
`;

const LabelSvg = styled.img`
display: block;
top: 0;
left: 0;
overflow: visible;
width: 163px;
height: 35px;
}
`;

const TextWrapper = styled.section`
  position: fixed;
  background: transparent;
  bottom: 80px;
  padding: 24px;
`;

const TextOverlay = styled.div`
  background-image: linear-gradient(
    to bottom,
    rgba(4, 3, 3, 0.5),
    rgba(4, 3, 3, 1)
  );
  position: fixed;
  bottom: 0px !important;
  width: 100%;
  height: 100%;
`;

const WelcomeTxt = styled.h1`
  font-family: Poppins;
  color: #fdfffc;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
`;

const HeadImage = styled.img`
  border-radius: 10px;
  width: 100%;
  margin-bottom: 10px;
`;

const ProductPrice = styled.h1`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #fffcf2;
  width: 70px;
  margin-top: 10px;
`;
const ProductLabel = styled.h1`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  color: #fffcf2;
  margin-top: 5px;
  margin-bottom: 40px;
`;
export default function Home() {
  const [show, setShow] = useState(false);
  const { shopifyId } = useShop();
  const BASE_URL = "https://catway.services.ombre.app/v1/";
  const [product, setProduct] = useState([]);

  useEffect(() => {
    getItem();
  }, [shopifyId]);

  const getItem = async () => {
    return axios
      .get(BASE_URL + "os/products/popular/" + shopifyId, {
        headers: {
          "x-ombre-hmac": await generateOmbreHMAC({
            shopifyShopId: shopifyId,
          }),
        },
      })
      .then((res) => {
        setProduct(res.data.data);
        console.log("show product", product);
      });
  };
  return (
    <>
      <div
        onMouseEnter={(e) => {
          e.preventDefault();
          setShow(true);
        }}
        onMouseLeave={(e) => {
          e.preventDefault();
          setShow(false);
        }}
      >
        <LoginBtn />
        <TitleHeader>Popular Item</TitleHeader>
        <Container>
          {product && product.length ? (
            <>
              {product.map((products) => (
                <>
                  {products.productImages.map((img) => (
                    <HeadImage src={img.imageSrc} />
                  ))}
                  <ProductPrice>RM{products.price}</ProductPrice>
                  <ProductLabel>{products.title}</ProductLabel>
                </>
              ))}
            </>
          ) : (
            <>
              {" "}
              <div
                className="d-flex justify-content-center"
                style={{ marginTop: "180px" }}
              >
                <LabelSvg src={errorimg} />
              </div>
              <div className="d-flex justify-content-center">
                <Error>Couldn't load product</Error>
              </div>
            </>
          )}
        </Container>

        {show && (
          <TextOverlay className="d-flex justify-content-center">
            <LoginBtn />
            <TextWrapper>
              <WelcomeTxt>
                Sign up with us now to get better results based on your body
                physique and shop stress-free!
              </WelcomeTxt>
            </TextWrapper>
            <div
              style={{
                textDecoration: "none",
                display: "flex",
                zIndex: "99999",
                bottom: "0px",
                position: "fixed",
                marginBottom: "40px",
              }}
            >
              {" "}
              <Buttons mode="Dark" autoWidth={true} types="Primary">
                <div onClick={() => navigate("/register")}>Sign Up Now</div>{" "}
              </Buttons>
            </div>
          </TextOverlay>
        )}
      </div>
    </>
  );
}
